import { memo, useCallback, useContext, useEffect, useState } from "react";
import { getTaxNoteSupplier } from "../../../../../../repositories/qerpapi/v3/screens-repositories/painel-nfe";
import { Grid, TextField } from "@material-ui/core";
import { EmissaoContext } from "../../../contexts/EmissaoContext";
import GFDataTable from "../../../../../../components/tables/GFDataTable";
import MaskService from "../../../../../../utils/mask/maskService";

let typingTimer = null;
const PurchaseSupplierTable = () => {
  const {
    selectedSupplier,
    setSelectedSupplier,
    setSelectedPurchaseNf,
    setSelectedPurchaseItems,
  } = useContext(EmissaoContext);

  const [firstSearch, setFirstSearch] = useState(true);
  const [filterSupplier, setFilterSupplier] = useState("");
  const [filterParams, setFilterParams] = useState({});

  const columnsSupplierSearch = [
    {
      label: "CÓD.",
      id: "id",
    },
    {
      label: "Razão Social",
      id: "razao",
      align: "center",
    },
    {
      label: "Fantasia",
      id: "apelido",
      align: "center",
    },
    {
      label: "CPF/CNPJ",
      id: "cgc",
      align: "center",
      format: (row) =>
        MaskService.toMask(
          (row.cgc || "").replace(/[^0-9]+/g, "").length === 11
            ? "cpf"
            : "cnpj",
          row.cgc || ""
        ),
    },
  ];

  const handleSearchSupplier = useCallback(() => {
    const filterOnlyNumbers = (filterSupplier || "").replace(/[^0-9]+/g, "");

    setFilterParams({
      supplierId: filterOnlyNumbers ? parseInt(filterOnlyNumbers) : "",
      supplierName: filterSupplier || "",
      supplierDocument: filterOnlyNumbers || "",
    });
  }, [filterSupplier]);

  useEffect(() => {
    if (firstSearch) return setFirstSearch(false);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      handleSearchSupplier();
    }, 2000);
    // eslint-disable-next-line
  }, [handleSearchSupplier]);

  useEffect(() => {
    setSelectedSupplier([]);
    setSelectedPurchaseNf([]);
    setSelectedPurchaseItems([]);
  }, [setSelectedPurchaseItems, setSelectedPurchaseNf, setSelectedSupplier]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={7}>
        <TextField
          label="Busque Por Qualquer Coluna Presente na Tabela"
          value={filterSupplier}
          onChange={({ target: { value } }) => {
            setFilterSupplier(value);
          }}
          variant="filled"
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <GFDataTable
          stickyHeader
          fnQuery={getTaxNoteSupplier}
          fnFiltersParams={filterParams}
          columns={columnsSupplierSearch}
          selectable={true}
          multiSelect={false}
          selected={selectedSupplier}
          setSelected={setSelectedSupplier}
        />
      </Grid>
    </Grid>
  );
};

export default memo(PurchaseSupplierTable);
